<script>
    export let list = [];
    export let whitelist = [];
    export let addToWhitelist;

    function excludeAccount(account) {
        if (typeof addToWhitelist === 'function') {
            addToWhitelist(account);
        }
    }

    export let removeFromWhitelist;

    function addAccount(account) {
        if (!isWhitelisted(account)) return;

        if (typeof removeFromWhitelist === 'function') {
            removeFromWhitelist(account);
        }
    }

    function isWhitelisted(account) {
        const itemIndex = whitelist.findIndex((item) => item.id == account.id);

        return itemIndex > -1 ? true : false;
    }

    function onImageError(event) {
        event.target.src = '/img/noavatar.jpg';
    }
</script>

<div class="widget-wrap">
    {#if list}
        {#each list as account}
            <a class="list-item block-relative block-relative-hover">
                <div>
                    <img src={`https://bot-removal.com${account.avatar}`}
                         class="block-relative-photo transform-hover"
                         on:click={addAccount(account)}
                         on:error={onImageError}
                    />

                    {#if !isWhitelisted(account)}
                        <img on:click={excludeAccount(account)} src="/static/media/flat-color-icons_ok.ec482660.svg" class="block-relative-ok transform-none" />
                    {/if}
                </div>
                <div class="bots-list-text-active">
                    <img src={`https://bot-removal.com${account.avatar}`}
                         class="photo-bots-min"
                         on:error={onImageError}
                    />

                    <p>
                        <a href="#" >@{account.username}</a>
                    </p>
                    <p></p>
                </div>
            </a>
        {/each}
    {/if}
</div>